import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";

import { ProfileViewData } from "modules/ProfileView/components";

type Props = {};

const ProfileViewContainer = (props: Props) => {

  return (
    <AppLayout>

      <ProfileViewData />


    </AppLayout>
  );
};

export default ProfileViewContainer;
